import { MONTH_LOWERCASE, MONTH_PASCAL } from '../constants';

const mapPascalMonthToLowercaseMonth = (
  month: MONTH_PASCAL
): MONTH_LOWERCASE => {
  const lowercaseMonth = month.toUpperCase() as keyof typeof MONTH_LOWERCASE;
  return MONTH_LOWERCASE[lowercaseMonth];
};

export default mapPascalMonthToLowercaseMonth;
